<div
  class="card card-custom"
  [ngClass]="{
    'card-body-progress': viewLoading,
    'card-body-progress-overlay': loadingAfterSubmit
  }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate>{{ getTitle() }}</h3>
    </div>
  </div>
  <!--begin::Form-->
  <form class="form" [formGroup]="relationshipEditForm" autocomplete="off">
    <div class="card-body">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>

      <div class="form-section form-section-first">
        <mat-form-field class="mat-form-field-fluid" appearance="fill">
          <mat-label>Entity</mat-label>
          <input type="text" matInput formControlName="entityInput" [matAutocomplete]="auto1" />
          <mat-autocomplete #auto1="matAutocomplete" [displayWith]="stringUtils.displayName">
            <mat-option *ngFor="let option of filteredOptions" [value]="option">
              <span>
                <div
                  [innerHTML]="stringUtils.autocompleteEntityFormatter(option) | safe : 'html'"
                ></div>
              </span>
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="isControlHasError('entityInput', 'required')">
            Please <strong>User</strong> is required
          </mat-error>
        </mat-form-field>
      </div>
      <div *ngIf="!data.contactEntity">
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label>Relation Category</mat-label>
          <mat-select formControlName="relationCategory">
            <mat-option *ngFor="let category of relationCategoryList" [value]="category">
              {{ category.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="relationshipEditForm.get('relationCategory').hasError('required')">
            Required field
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label>Description</mat-label>
          <mat-select formControlName="relationCategoryDescription">
            <mat-option
              *ngFor="let description of relationCategoryDescriptionList"
              [value]="description"
            >
              {{ description.description_type }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="relationshipEditForm.get('relationCategoryDescription').hasError('required')"
          >
            Required field
          </mat-error>
        </mat-form-field>
        <div class="mat-form-field-fluid mb-4">
          <mat-label class="row ml-1">Primary</mat-label>
          <mat-slide-toggle class="mr-2" formControlName="isPrimary"></mat-slide-toggle>
          <mat-hint align="start">
            <strong>{{ getPrimaryString('isPrimary') }}</strong>
          </mat-hint>
        </div>
        <div class="mat-form-field-fluid mb-4">
          <mat-label class="row ml-1">Financial Responsible</mat-label>
          <mat-slide-toggle class="mr-2" formControlName="financialResponsible"></mat-slide-toggle>
          <mat-hint align="start">
            <strong>{{ getPrimaryString('financialResponsible') }}</strong>
          </mat-hint>
        </div>

        <div class="mat-form-field-fluid mb-4">
          <mat-label class="row ml-1">Emergency Contact</mat-label>
          <mat-slide-toggle class="mr-2" formControlName="emergencyContact"></mat-slide-toggle>
          <mat-hint align="start">
            <strong>{{ getPrimaryString('emergencyContact') }}</strong>
          </mat-hint>
        </div>

        <div class="mat-form-field-fluid mb-4">
          <mat-label class="row ml-1">PHI Authorized</mat-label>
          <mat-slide-toggle class="mr-2" formControlName="phiAuthorized"></mat-slide-toggle>
          <mat-hint align="start">
            <strong>{{ getPrimaryString('phiAuthorized') }}</strong>
          </mat-hint>
        </div>
      </div>
    </div>
    <!--    </div>-->
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            cdkFocusInitial
            (click)="onNoClick()"
            matTooltip="Cancel changes"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="submit"
            mat-raised-button
            color="primary"
            (click)="save()"
            [disabled]="viewLoading"
            matTooltip="Save changes"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
  <!--end::Form-->
</div>
